import { Controller } from 'stimulus';
import Utility from '../classes/Utility';
import RequestQueue from '../classes/RequestQueue';
import MitreTable from '../utils/mitre-table';

class Filter extends Controller {
  static targets = [
    'resultsCounter'
  ];

  initialize() {
    const tableKey = this.element.closest('[data-table-key-value]').getAttribute('data-table-key-value');
    this._mitreTable = MitreTable.getByTableKey(tableKey);

    this.body = document.querySelector('body');
  }

  async connect() {
    this._updateFilterCounter();

    EventManager.on('update_filter', (data) => {
      this._mitreTable.emit('interaction', { type: MitreTable.InteractionType.FILTER_CHANGE});
      if (MitreTable.areInteractionsLocked()) return;

      this._setFilters(data);
      this._updateFilterCounter();
    });

    EventManager.on('filter_button_state', ({ element, state }) => {
      this._setButtonState(element, state);
    });

    EventManager.on('scroll_container', ({ selector, container }) => {
      this._scrollContainer(selector, container);
    });

    this._mitreTable.on('update_filter_counter', () => this._updateFilterCounter());

    this._mitreTable.on('apply_default_filter', (data) => {  // emitters: checkbox_list_filter_controller.js
      this._mitreTable.emit('interaction', { type: MitreTable.InteractionType.FILTER_CHANGE});
      if (MitreTable.areInteractionsLocked()) return;

      this._setFilters(data);
      this._applyFilters();
      this._updateFilterCounter();
    });
  }

  disconnect() {
  }

  reset() {
    this._mitreTable.emit('interaction', { type: MitreTable.InteractionType.FILTER_CHANGE});
    if (MitreTable.areInteractionsLocked()) return;

    this._mitreTable.setParam('filters', {});
    this._mitreTable.emit('reset_filters');

    this._updateFilterCounter();
    this._updateTableBody();
  }

  apply() {
    this._applyFilters();
    this.popupState();
    this._updateTableBody();
  }

  popupState() {
    if (this.body.classList.contains('t-overflow-hidden')) {
      this.body.classList.remove('t-overflow-hidden');
    } else {
      this.body.classList.add('t-overflow-hidden');
    }
  }

  _applyFilters() {
    const { filters: currentFilters } = this._mitreTable.getParams();
    if(currentFilters) {
      for (const filterKey in currentFilters) {
        currentFilters[filterKey].selected = true;
      }
      this._mitreTable.setParam('filters', currentFilters);
    }
  }

  _setFilters(filterData) {
    const { filters: currentFilters } = this._mitreTable.getParams();
    currentFilters[filterData.filterKey] = filterData;
    this._mitreTable.setParam('filters', currentFilters);
  }

  async _updateFilterCounter() {
    const {
      collectionKey,
      filters,
      defaultFilters,
      theme,
      specialTheme
    } = this._mitreTable.getParams();

    for(let filter in filters) {
      filters[filter].selected = true;
    }

    const { data } = await RequestQueue.addToQueue({
      url: '/api/t2/total_count/',
      method: 'post',
      data: {
        uuid: this._mitreTable.tableKey,
        default_filters: defaultFilters,
        filters,
        collection: collectionKey,
        theme,
        special_theme: specialTheme
      }
    });

    const { total } = data;
    this.resultsCounterTargets.forEach((el) => el.innerHTML = total);
  }

  _updateTableBody() {
    this._mitreTable.emit('table-body-update', { pagination: 1 });

    EventManager.emit('collection-filters-update', {
      collection: this.element.closest('[data-collection-key]').getAttribute('data-collection-key')
    });
  }

  _setButtonState(element, state) {
    if (element.classList.contains('t-bg-mitre-gray-200')) {
      element.classList.remove('t-bg-mitre-gray-200');
    }

    if(state) {
      element.classList.add('t-bg-mitre-gray-200');
    }
  }

  _scrollContainer(selector, container) {
    let filterHeight = document.getElementById('filter-popup-container').clientHeight;
    let containerOffset = container.offsetTop;
    let height = selector.clientHeight;

    if(filterHeight <= containerOffset && Utility.getDeviceType() === 'dt') {
      document.getElementById('filter-popup-container').scrollTop = filterHeight + height;
    } else if (filterHeight <= containerOffset) {
      document.getElementById('filter-popup-container').scrollTop += height;
    }
  }
}

export default Filter;
